import { AllowanceStateTypes, AllowanceActionTypes } from "./Allowance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllowanceStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllowanceReducer = (
  state: AllowanceStateTypes = INITIAL_STATE,
  action: any
): AllowanceStateTypes => {
  switch (action.type) {
    case AllowanceActionTypes.FETCH_ALL_ALLOWANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllowanceActionTypes.FETCH_ALL_ALLOWANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllowanceActionTypes.FETCH_ALL_ALLOWANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllowanceActionTypes.FETCH_ALL_ALLOWANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllowanceActionTypes.FETCH_ONE_ALLOWANCE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllowanceActionTypes.FETCH_ONE_ALLOWANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllowanceActionTypes.FETCH_ONE_ALLOWANCE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllowanceActionTypes.FETCH_ONE_ALLOWANCE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllowanceReducer;
